const faqData = [
    {
      title: "Product & Subscription Basics",
    },
    {
      title: "Free Trial Details",
    },
    {
      title: "Trial Flow & Expiry",
    },
    {
      title: "Existing Users & Upgrades",
    },
    {
      title: "Payment, Pricing & Discounts",
    },
    {
      title: "AI Widgets & Advanced Features",
    },
    // {
    //   title: "Newsletter & Post-Trial Engagement",
    // },
    {
      title: "Cancellation & Refunds",
    }
  ];
  
  export default faqData;